<script>
import DeviceDetector from 'vue-device-detector';

export default {
    name: 'CpDownloadAppMobileDialog',
    components: {
        CpButton: require('../button').default,
        CpDialog: require('../dialog').default,
        CpBoxContent: require('../box-content').default,
        CpBox: require('../box').default,
    },
    props: {
        handleDialog: Function,
    },
    data() {
        return {
            iosApp: process.env.MIX_IOS_STORE_URL,
            androidApp: process.env.MIX_ANDROID_STORE_URL,
        };
    },
    methods: {},
    computed: {}
};
</script>
<template>
    <cp-dialog>
        <cp-box>
            <section>
                <template class="share-container">
                    <div class="container">
                        <svg @click.prevent="handleDialog()" class="close-btn" stroke="currentColor" fill="currentColor"
                            stroke-width="0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z">
                            </path>
                        </svg>
                        <div class="video-container">
                            <video autoplay loop muted width="300">
                                <source src="assets/animations/download-app-video-webm.webm" type="video/webm" />
                                <source src="assets/animations/download-app-video-mp4.mp4" type="video/mp4" />
                            </video>
                        </div>
                        <div class="download-container">
                            <h2 class="black-color H3 title">
                                Download our app
                            </h2>
                            <p class="neutral5-color body1 subtitle">
                                Fund, Follow, Advocate – CrowdBlue, Your Political Powerhouse App!
                            </p>
                            <div class="download-section-container">
                                <img src="assets/img/crowdblue-qr-code.png" alt="Download qr code" class="qr-code">
                                <div class="btn-container">
                                    <a class="ios-btn" :href="iosApp" target="_blank" rel="noopener noreferrer">
                                        <img src="assets/img/app-store.svg" alt="App Store image">
                                    </a>
                                    <a class="android-btn" :href="androidApp" target="_blank" rel="noopener noreferrer">
                                        <img src="assets/img/google-play.svg" alt="Google Play image">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </section>
        </cp-box>
    </cp-dialog>
</template>
<style scoped>
.container {
    display: flex;
    justify-content: center;
    height: 270px;
}

.video-container {
    width: 45%;
}

.download-container {
    display: flex;
    flex-direction: column;
    width: 55%;
    padding-top: 20px;
}

.title {
    margin-bottom: 0px;
}

.subtitle {
    width: 80%;
}

.download-section-container {
    display: flex;
    padding-top: 8px;
}

.btn-container {
    display: flex;
    flex-direction: column;
    padding-left: 20px;
}

.ios-btn,
.android-btn {
    text-decoration: none;
}

.ios-btn {
    padding-bottom: 5px;
    padding-right: 14px;
}

.qr-code {
    max-width: 120px;
}

.close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    height: 2.5em;
    width: 2.5em;
    cursor: pointer;
}
</style>
